import { Container, Divider, Grid } from '@material-ui/core';
import { ArrowBack, Save as SaveIcon } from '@material-ui/icons';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import ButtonUI from '../../components/ui/ButtonUI';
import PageTitle from '../../components/ui/PageTitleUI';
import { useAuth } from '../../hooks/auth';
import { InfoMvmAddTransportOrder } from '../../interfaces/Mvm';
import MvmApi from '../../services/MvmApi';
import permissions from '../../utils/Permissions';
import MvmRackLoadList from './components/MvmRackLoadList';
import MvmSummary from './components/MvmSummary';
import { useStyles } from './Style';

interface Params {
    mvmId: string;
}

interface IFormInput {
    mvmNumber: any;
    rackLoads: any;
}

const AddMvmTransportOrder: React.FC = () => {
    const params = useParams<Params>()
    const history = useHistory()
    const classes = useStyles()
    const { t } = useTranslation("Mvm")
    const { t: _t } = useTranslation("General")
    const { enqueueSnackbar } = useSnackbar()
    const [mvmId, setMvmId] = useState<number>(0)
    const { user, hasPermission } = useAuth();
    const [queryMvmId, setQueryMvmId] = useState<any>(null)
    const { control, handleSubmit, setValue, getValues } = useForm<IFormInput>(
    {
        defaultValues: { mvmNumber: {} }
    })

    useEffect(() => {
        if (!hasPermission(permissions.MVM.PendingBilling))
            history.replace('NoPermission');
    }, [history, user])

    useEffect(() => {
        if (params.mvmId)
            setQueryMvmId(params.mvmId);

    }, [params.mvmId]);

    const onSummaryChange = (data: any) => {
        
        if (!data) {
            setMvmId(0)
            return
        }

        setMvmId(data.id)

        //Cada Shed tem uma colecao de RackLoads - esta tela deve exibir todos os racks de todos os sheds
        let rackLoads: any = [];
        data.sheds.forEach((x: any) => {
            //Incluir os rackLoads de cada shed na lista:
            x.rackLoads.forEach((y: any) => {         
                y.rackLoadId = y.id; //Setar este ID para obter depois, pois a propriedade "id" é sobrescrita pelo react hook form FieldArray
                rackLoads.push(y);
            });
        });

        setValue("rackLoads", rackLoads)
    }

    const onSubmit = (data: any) => {
        if (mvmId == 0) {
            enqueueSnackbar(t("returnSearchMvmNotFoundMessage"), { variant: 'warning' })
            return
        }

        let hasErrors: boolean = false;

        let putObject: InfoMvmAddTransportOrder = { 
            id: mvmId, 
            rackLoadRequestNumbers: {}
        }
        
        data.rackLoads.forEach((e: any) => 
        {
            if (e.hasError) //Se tem algum erro em tela no campo da nota fiscal, cancelar a operacao
                hasErrors = true;

            putObject.rackLoadRequestNumbers[e.rackLoadId.toString()] = e.requestNumber;
        });

        if (!hasErrors)
            MvmApi.addMvmTransportOrder(putObject)
            .then(() => {
                enqueueSnackbar(_t("returnSubmitEditFormSuccess"), { variant: 'success' });
                history.push('/PendingTransportOrder');
            })
    }

    return (
        <Container maxWidth={false} component="main">
    
            <PageTitle title={t("titleTransportOrderInsert")} />

            <div className={classes.rootContent}>
                <form onSubmit={handleSubmit(onSubmit)} >                    
                    <Divider style={{ marginTop: '10px' }} />
                    <MvmSummary
                        control={control}
                        name={"summary"}
                        onChange={onSummaryChange}
                        setValue={setValue}
                        queryMvmId={queryMvmId}
                        includeProperties={["Sheds"]}
                    />
                </form>
                    
                {mvmId == 0 ? <></> :   
                    <Grid container spacing={1}>
                            <Grid item xs={12}>
                                {
                                    <>
                                        <MvmRackLoadList
                                            control={control}
                                            title={t('titleAddTransportOrder')}
                                            name={"rackLoads"}
                                            allowAdd={false}
                                            allowDelete={false}
                                            allowInvoiceEdit={false}
                                            allowRequestNumberEdit={true}
                                            showColumns={['transportOrder']}
                                        />
                                    </>
                                }
                            </Grid>
                            <ButtonUI
                                style={{ marginTop: 15, marginLeft: 15 }}
                                variant="outlined"
                                color="primary"
                                onClick={() => onSubmit(getValues())}
                                startIcon={<SaveIcon />}>
                                {_t("save")}
                            </ButtonUI>
                            <ButtonUI
                                style={{ marginTop: 15 }}
                                variant="outlined"
                                color="secondary"
                                onClick={() => history.replace('/PendingTransportOrder')}
                                startIcon={<ArrowBack />}>
                                {'Voltar '}
                            </ButtonUI>
                    </Grid>
                }
            </div>
        </Container>
    )
}
export default AddMvmTransportOrder;
